module.exports = __webpack_public_path__ + "static/media/KimberleyEcho-devicecomp-min@2x.363dc3b2.webp";